<template>
    <div class="workorderInfromation">
        <div class="workorderInfromation_title">
            <div class="workorderInfromation_t_zhzx ZX" v-if="timeLineData.czCzjskey=='WGSJ_WGY'">
                网格员
            </div>
            <div class="workorderInfromation_t_zhzx ZX" v-else-if="timeLineData.czCzjskey=='WGSJ_ZX'">
                指挥中心
            </div>
            <div class="workorderInfromation_t_zhzx ZX" v-else>
               {{timeLineData.czCzdwmc}}
            </div>
            <div class="workorderInfromation_t_describe QZX">
                {{timeLineData.czCzrmc}}
            </div>
            <div class="workorderInfromation_t_describe">
                创建工单
            </div>
        </div>
        <div class="workorderInfromation_progressTime">
            <span class="icon-time_fill workorderInfromation_icon"></span>
            <div class="workorderInfromation_p_time">
                {{timeLineData.czCzsj}}
            </div>
            <div class="workorderInfromation_p_day">
                第{{timeLineData.theDay}}天
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "timeLine_CJGD",
        props:["timeLineList"],
        setup(props, context) {
            // let timeLineData = reactive({
            //     "czCzdwmc": "指挥中心",//处置单位名称
            //     "czCzrmc": "张倩",  //处置人名称
            //     "czCzsj": "2021.12.02 14:11:38", //处置时间
            //     "theDay": "1", //第n天"
            // })
            let timeLineData = props.timeLineList;
            return {
                timeLineData,
            }
        }
    }
</script>

<style scoped>

</style>
